import { Component } from '@angular/core';

@Component({
    selector:'nav-app',
    templateUrl:'./navapp.component.html'
})
export class NavAppComponent {
    
}


// WEBPACK FOOTER //
// ./src/app/view/auth/nav-app/navapp.component.ts